import React from 'react';
import { useApp } from '../../context/AppContext';
import { incidentsAPI } from '../../services/api';
import IncidentForm from './IncidentForm';

const IncidentModal = ({ isOpen, onClose }) => {
  const { addNotification } = useApp();

  const handleSaveIncident = async (incidentData) => {
    try {
      await incidentsAPI.create(incidentData);

      addNotification({
        type: 'success',
        message: 'Incidencia reportada exitosamente'
      });

      onClose();
    } catch (error) {
      console.error('Error creating incident:', error);
      addNotification({
        type: 'error',
        message: 'Error al reportar la incidencia'
      });
      throw error; // Re-throw so IncidentForm can handle loading state
    }
  };

  if (!isOpen) return null;

  return (
    <IncidentForm
      incident={null} // Always creating new incident
      onSave={handleSaveIncident}
      onClose={onClose}
    />
  );
};

export default IncidentModal;